import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getJiraSummarySlice } from '../get';
import { postJiraStatuses } from '@api';

export const postJiraStatusesSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary ]
	},
	name: 'jiraStatuses',
	receive: false,
	request: true,
	requestHandler: postJiraStatuses
});
